<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 */
import { defineAsyncComponent } from "vue";
import { hasConfig } from "@/composables/utils/template";
import type { SecondaryDataInterface } from "@/types/ContentType";

const GoogleMap = process.client ? defineAsyncComponent({
  loader: () => import("@/components/regularComponents/UIComponents/GoogleMap/GoogleMap.vue"),
  timeout: 4000,
}) : null;

defineProps<{
  contentData?: SecondaryDataInterface;
}>();
</script>

<template>
  <div
    :class="[
      'google-map-wrapper',
      { 'padding--big': hasConfig(contentData, 'padding-top-big') },
    ]"
  >
    <GoogleMap class="contact-block__map" v-bind="{ contentData }" />
  </div>
</template>

<style lang="scss">
.google-map-wrapper {
  padding-top: 208px;

  @include maxq(desktop-2k) {
    padding-top: 138px;
  }

  @include maxq(desktop-lg) {
    padding-top: 104px;
  }

  .padding--big {
    padding-top: 200px;
    @include maxq(mobile) {
      padding-bottom: 120px;
    }
  }
}
.custom-select__item {
  text-align: left;
}

.google-map {
  position: relative;
  padding-top: 1500px;

  @include maxq(desktop-2k) {
    padding-top: 1000px;
  }

  @include maxq(desktop-lg) {
    padding-top: 786px;
  }
  @include maxq(mobile-sm) {
    padding-top: 500px;
  }

  &__map {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
